export const featureFlags = [
  'spanish',
  'counterOfferEnabled',
  'in_store_apps_enabled',
] as const;

type FeatureFlag = (typeof featureFlags)[number];
export type FeatureFlags = { [key in FeatureFlag]?: string };
